import { CSSObject } from '@chakra-ui/react';

export const StyledDatePicker: CSSObject = {
  '&&&': {
    '.chakra-input, .react-date-picker__wrapper': {
      h: '40px',
      background: 'blackAlpha.500',
      color: 'white',
      borderRadius: 'md',
      transition: 'all .2s ease-in-out',
      fontSize: 'xs',
      px: '2',
      border: 'none',
      'input, span': {
        fontFamily: 'body',
        fontWeight: 'normal',
        display: 'inline-block',
      },
      button: {
        color: 'beta.300',
      },
      boxShadow: 'none',
      _hover: {
        opacity: 0.9,
      },
    },
  },
};
